<app-choose-game class="slide-out" [ngStyle]="{'display': routeService.previousUrl == '/choose' ? 'block' : 'none'}"
  id="chooseGame"></app-choose-game>

<div class="page" [ngClass]="{'info-background': gameInfoOpen, 'game-background': !gameInfoOpen}">
  <app-header></app-header>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3; top: 0;"
    src="../../assets/anim/BG-trivia.json" background="transparent" speed="1" autoplay>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3; top: 0;"
    src="../../assets/anim/birds-trivia.json" background="transparent" speed="0.5" autoplay loop>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 4; top: 0;"
    src="../../assets/anim/bridgeTreesTrivia.json" background="transparent" speed="0.9" autoplay>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3; top: 0;"
    src="../../assets/anim/Cloud1.json" background="transparent" speed="0.5" autoplay loop>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3; top: 0;"
    src="../../assets/anim/Cloud2.json" background="transparent" speed="0.8" autoplay loop>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 4; top: 0;"
    src="../../assets/anim/Cloud3.json" background="transparent" speed="0.7" autoplay loop>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3; top: 0;"
    src="../../assets/anim/Moon-trivia.json" background="transparent" speed="0.3" autoplay>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3; top: 0;"
    src="../../assets/anim/Mountain-trivia.json" background="transparent" speed="1" autoplay>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3; top: 0;"
    src="../../assets/anim/Train-trivia.json" background="transparent" speed="0.8" autoplay loop>
  </lottie-player>

  <app-game-info *ngIf="gameInfoOpen" (gameInfoOpen)="closeInfo()" [game]="game"></app-game-info>

  <div *ngIf="!gameInfoOpen">

    <app-game-play [game]="game"></app-game-play>
    <div class="game-container" [ngStyle]="{'opacity': chooseLane ? '0.5' : '1'}">

      <app-trivia-map></app-trivia-map>

      <div id="question-container" [hidden]="!question && !replaceQuestion">
        <div class="backdrop go-in flex-center" id="backdrop">
          <div class="question-container scale-in-pop" id="quesiton-cont">
            <img id="question-logo" src="./assets/images/icons/qa.png">
            <div class="help-container-trivia">
              <div class="flex-align">גלגלי הצלה</div>
              <div class="flex-align">
                <div class="orange-circle">
                  <div class="help replace" (click)="onHelp('replace')" *ngIf="question"
                    [ngClass]="{'used': !replaceHelper}">
                  </div>
                </div>
                <div class="orange-circle">
                  <div class="help" id="half" (click)="onHelp('half')" *ngIf="question"
                    [ngClass]="{'used': !halfHelper, 'half': question.type == 'trivia', 'plus2': question.type == 'complete'}">
                  </div>
                </div>
              </div>
            </div>
            <div id="trivia-container" *ngIf="question && question.type == 'trivia'">
              <h2>{{question.question}}?</h2>
              <div class="answer-container" [ngClass]="{'disapear': question.answers[random] == ''}"
                *ngFor="let random of randoms">
                <div id="result{{random}}" class="result-img"></div>
                <button class="answer flex-align" (click)="onTriviaAnswer($event)" id="{{random}}"
                  [disabled]="question.answers[random] == ''">
                  <h3>{{question.answers[random]}}</h3>
                </button>
              </div>
            </div>
            <div id="complete-container" *ngIf="question && question.type == 'complete'">
              <img src="{{question.src}}">
              <h2>{{question.question}}?</h2>
              <div class="flex-center">
                <input *ngFor="let letter of lettersArray; let i = index; let last = last" maxlength="1" type="text"
                  id="{{i}}" appCompleteTheWord [isLast]="last" (ngType)="onType($event)" (ngInit)="onNewWord()"
                  tabindex="0">
              </div>
              <button class="btn btn-success" (click)="onCompleteAnswer()">אישור</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="chooseLane">
      <div class="backdrop" id="backdrop">
        <div id="choose-container">

          <h1>בחר נתיב</h1>

          <div class="flex-evenly" style="margin-bottom: 22px;">

            <div (click)="changeLane('pink')" class="lane-container"
              *ngIf="(this.crossroad == 'pink-green' || this.crossroad == 'pink-orange' || this.crossroad == 'pink-green-red')">
              <img class="train-img" src="../../assets/images/icons/pink-train.png">
              <div class="flex-center" style="margin-top: 20px;">
                <h2>1000</h2>
                <img class="coin-train-lane" src="../../assets/images/icons/money.png">
              </div>
            </div>
            <div (click)="changeLane('green')" class="lane-container"
              *ngIf="(this.crossroad == 'pink-green' || this.crossroad == 'green-orange' || this.crossroad == 'pink-green-red')">
              <img class="train-img" src="../../assets/images/icons/green-train.png">
              <div class="flex-center" style="margin-top: 20px;">
                <h2>x2</h2>
                <img class="coin-train-lane" src="../../assets/images/icons/money.png">
              </div>
            </div>
            <div (click)="changeLane('orange')" class="lane-container"
              *ngIf="(this.crossroad == 'pink-orange' || this.crossroad == 'green-orange' || this.crossroad == 'orange-red')">
              <img class="train-img" src="../../assets/images/icons/orange-train.png">
              <div class="flex-center" style="margin-top: 20px;">
                <h2>x3</h2>
                <img class="coin-train-lane" src="../../assets/images/icons/money.png">
              </div>
            </div>
            <div (click)="changeLane('red')" class="lane-container"
              *ngIf="(this.crossroad == 'pink-green-red' || this.crossroad == 'orange-red')">
              <img class="train-img" src="../../assets/images/icons/red-train.png">
              <div class="flex-center" style="margin-top: 20px;">
                <h2>x4</h2>
                <img class="coin-train-lane" src="../../assets/images/icons/money.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
